import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { TIME_OF_NIGHT_OPTIONS } from '@/pages/Onboarding/options/TimeOfNight/TIME_OF_NIGHT_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenTimeOfNight: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'TimeOfNight',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const timeOfNight = form.watch('time_of_night');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['time_of_night']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        timeOfNight: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const handleBack = () => {
    wizard.goToStep('setting_selector');
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation onBack={handleBack} />

      <IonContent>
        <OwnAiTitle>What time is it when it starts?</OwnAiTitle>
        <OnboardingOptionsList>
          {TIME_OF_NIGHT_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={timeOfNight === option.id}
              control={form.control}
              option={option}
              name="time_of_night"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`time-of-night-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
